import axiosClient from './axiosClient.js'
import { textUrl } from '../config/sources';

// All years: https://raw.githubusercontent.com/QuizSystem/ETSData/master/{year}/test{n}/part{p}.json
// (Legacy ETS2020Texts retired — copyright / AdSense DMCA)
const textAPI = {
  get: (year, test, part) => {
    return axiosClient.get(textUrl(year, test, part));
  },
}

export default textAPI;
